export default __webpack_public_path__ + "b0f1f145cc2d81b1ed35a79d22c42efe.png";